export default function Breadcrumb() {
  const BREADCRUMB = document.querySelector('.m-breadcrumb')

  if (!BREADCRUMB) return

  const links = BREADCRUMB.querySelectorAll('a')
  const separators = BREADCRUMB.querySelectorAll('span')

  let widthLinks = 0
  let numebrLinks = 0
  let widthSeparators = 0

  links.forEach((item) => {
    widthLinks += item.scrollWidth
    numebrLinks++
  })

  separators.forEach((span) => {
    widthSeparators += span.scrollWidth
  })

  const totalMinWidth = widthLinks + widthSeparators + 14 * numebrLinks + 24

  const container = BREADCRUMB.querySelector('.a-container')
  if (container) {
    container.style.minWidth = `${totalMinWidth}px`
  }
}
